import React from "react";
import styles from "./styles.module.scss";

const PermissionSkeleton = () => {
  return <div className={styles.skeleton_item} />;
};

export default PermissionSkeleton;
